module.exports = __webpack_public_path__ + "static/img/rotationPlot_1.f6958e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rotationPlot/rotationPlot_1.jpg
// module id = TyuF
// module chunks = 0